import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Image } from './styles';
var Logo = function (_a) {
    var style = _a.style;
    var theme = useSelector(function (state) { return state.theme; }).theme;
    var _b = useState(!!theme.logo), showLogo = _b[0], setShowLogo = _b[1];
    if (!theme.logo || !showLogo) {
        return null;
    }
    return (React.createElement(Image, { style: style, src: theme.logo, alt: "Logo", onError: function () { return setShowLogo(false); } }));
};
export default React.memo(Logo);
